import { requestPhoenix } from '../../network';
import { KalturaDetachedResponseProfile, KalturaLoginSession, KalturaOnDemandResponseProfile } from '../../objects';

export type AnonymousLoginArgs = {
  partnerId: number;
  responseProfile?: KalturaDetachedResponseProfile | KalturaOnDemandResponseProfile;
  udid?: string;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/ottUser/action/anonymousLogin
 */
export async function loginAnonymous(body: AnonymousLoginArgs) {
  return requestPhoenix<KalturaLoginSession>({
    path: '/ottuser/action/anonymousLogin',
    body,
  });
}
